import { render } from "./BoosterTree.vue?vue&type=template&id=317cb410&scoped=true"
import script from "./BoosterTree.vue?vue&type=script&lang=js"
export * from "./BoosterTree.vue?vue&type=script&lang=js"

import "./BoosterTree.vue?vue&type=style&index=0&id=317cb410&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317cb410"]])

export default __exports__